import React from 'react';
import ReactDOM from 'react-dom/client';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import weekday from 'dayjs/plugin/weekday';
import localeData from 'dayjs/plugin/localeData';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import quarterOfYear from 'dayjs/plugin/quarterOfYear';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { setupAxiosInterceptors } from './utils/axiosInterceptor';
import * as serviceWorker from './serviceWorker';

// Setup axios interceptors to handle 401 Unauthorized errors
setupAxiosInterceptors();

// Configure dayjs plugins - Required for Ant Design DatePicker to work correctly
dayjs.extend(customParseFormat);
dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.extend(weekOfYear);
dayjs.extend(advancedFormat);
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
dayjs.extend(quarterOfYear);

const root = ReactDOM.createRoot(document.getElementById("root"));

// Check if REACT_APP_ORGANIZATION_UUID is set
if (!process.env.REACT_APP_ORGANIZATION_UUID || process.env.REACT_APP_ORGANIZATION_UUID.trim() === '') {
  // Display error message if organization UUID is not set
  root.render(
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      backgroundColor: '#f8d7da',
      color: '#721c24',
      fontFamily: 'Arial, sans-serif',
      textAlign: 'center',
      padding: '20px'
    }}>
      <div>
        <h1 style={{ fontSize: '24px', marginBottom: '10px' }}>Configuration Error</h1>
        <p style={{ fontSize: '18px', margin: '10px 0' }}>
          Organization is not set.
        </p>
        <p style={{ fontSize: '16px', margin: '10px 0' }}>
          Please contact the administrator.
        </p>
      </div>
    </div>
  );
} else {
  // Render the app normally if organization UUID is set
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

// Register the service worker so the app is installable and survives a flaky
// connection. When a new build lands, tell the user rather than silently
// leaving a home-screen app on a stale bundle.
serviceWorker.register({
  onUpdate: (registration) => {
    const waiting = registration.waiting;
    if (!waiting) return;
    // antd isn't mounted yet at module scope, so keep this dependency-free.
    // `controllerchange` in serviceWorker.js reloads once the new worker is in.
    if (window.confirm('A new version of Teson CRM is available. Reload now?')) {
      waiting.postMessage({ type: 'SKIP_WAITING' });
    }
  },
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
